

export const API_URL = "https://api.mylions306d6.org/";
//export const API_URL = "http://localhost/";

//const API_URL = "https://api.cms.lions306c1.org/";

//export default API_URL;